export default "__VITE_ASSET__kVoOnmxH__"